// vant的toast提示框组件，大家可根据自己的ui组件更改。
import axios from 'axios';
import qs from 'qs';
//qs.stringify()   qs.parse()
import api from './api'
// 配置API接口地址
var domain = api.domain
axios.defaults.baseURL = api.baseURL;

// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
/** 参数过滤函数*/
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
 
//其实success与failure这两个参数，传过来的是两个放方法
function apiAxios (method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  params.domain = domain //本地

  let english_short_name=sessionStorage.getItem('english_short_name');
  if(english_short_name){
    params.english_short_name = english_short_name
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(params): null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    }
  })
    .then(function (res) {
      if (res.data.code === 0) {
        if (success) {
		      //使用success(data)方法
          success(res.data)
        }
      } else {
        bld_VM.$message({
          message:res.data.msg,
          type: 'error'
        })
        if (failure) {
          failure(res.data)
        }
        
      }
    })
    .catch(function (err) {
      if (err) {
        bld_VM.$message({
          message:err,
          type: 'error'
        })
      }
    })
}
 
// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  }
}


// WEBPACK FOOTER //
// ./src/utils/axios.js